module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "frontsales",
    attrs: {
      "id": "frontsales_1"
    }
  }, [_c('p', {
    staticClass: "fm1"
  }, [_c('strong', [_vm._v("She had no clue why Caleb was kissing her, but she didn’t care.")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("S")]), _vm._v("he drank it in, starving for the contact of a man after being alone for so long. And not just any man. Caleb. A hero with a body that was carved by the hand of God for a woman’s pleasure. He was strength personified, and she felt all those masculine ridges pressing against her body.")]), _vm._v(" "), _c('p', [_vm._v("His tongue teased her mouth open and she gave him entry, sighing with pleasure. One wide hand pressed against the small of her back, holding her tight to his hard body while the other hand cradled her head, guiding her so he could nibble his way to her ear. She mourned the loss of his mouth on hers, tried to coax him back, but he held her immobile.")]), _vm._v(" "), _c('p', [_vm._v("In a quiet, breathless voice, he said, “You’re being watched. Play along.”")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('strong', [_vm._v("Acclaim for Shannon K. Butcher’s previous novel "), _c('em', [_vm._v("No Regrets")])])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Action, adventure, and romance with as many twists and turns as a roller-coaster ride.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_vm._v("—Cindy Gerard, "), _c('em', [_vm._v("USA Today")]), _vm._v(" bestselling author of "), _c('em', [_vm._v("Under the Wire")])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Excitement, adventure, and steamy scenes . . . a delightful read.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_vm._v("—BookLoons.com")]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“A fast-paced, action-packed suspense with great characters and a wonderful romance that will leave readers breathless.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_vm._v("—SuspenseRomanceWriters.com")]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“In "), _c('em', [_vm._v("No Regrets")]), _vm._v(", Shannon K. Butcher’s terrific debut novel, the author deftly combines an exciting suspense plot with a spark-filled romance.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_vm._v("—ArmchairInterviews.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f49fc2f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoControl_fron_1.vue
// module id = 66
// module chunks = 0